import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPatGenerators = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.06747 9.81335C8.27411 10.0415 8.56757 10.1717 8.87539 10.1717C9.18321 10.1717 9.47668 10.0415 9.68331 9.81335L10.2058 9.23001C10.5145 8.88865 11.0045 8.77837 11.4297 8.95457C11.8549 9.13077 12.1232 9.55537 12.1 10.015L12.0608 10.7933C12.0435 11.1013 12.1583 11.4021 12.3764 11.6203C12.5945 11.8384 12.8953 11.9532 13.2033 11.9358L13.9816 11.8967C14.4416 11.8728 14.8667 12.1412 15.0429 12.5667C15.2191 12.9923 15.1081 13.4826 14.7658 13.7908L14.1875 14.3133C13.9588 14.5197 13.8283 14.8133 13.8283 15.1213C13.8283 15.4293 13.9588 15.7228 14.1875 15.9292L14.7658 16.4517C15.1081 16.7599 15.2191 17.2502 15.0429 17.6758C14.8667 18.1013 14.4416 18.3698 13.9816 18.3458L13.2033 18.3067C12.8957 18.2907 12.5957 18.4059 12.3779 18.6237C12.16 18.8416 12.0448 19.1415 12.0608 19.4492L12.1 20.2275C12.1232 20.6872 11.8549 21.1118 11.4297 21.288C11.0045 21.4642 10.5145 21.3539 10.2058 21.0125L9.68331 20.4292C9.47668 20.201 9.18321 20.0709 8.87539 20.0709C8.56757 20.0709 8.27411 20.201 8.06747 20.4292L7.54497 21.0125C7.23629 21.3539 6.74624 21.4642 6.32108 21.288C5.89591 21.1118 5.62754 20.6872 5.65081 20.2275L5.68997 19.4492C5.70544 19.1417 5.59004 18.842 5.37234 18.6243C5.15464 18.4066 4.85497 18.2912 4.54747 18.3067L3.76914 18.3458C3.3095 18.3691 2.8849 18.1007 2.7087 17.6756C2.5325 17.2504 2.64278 16.7604 2.98414 16.4517L3.56331 15.9292C3.79147 15.7225 3.92162 15.4291 3.92162 15.1213C3.92162 14.8134 3.79147 14.52 3.56331 14.3133L2.98414 13.7908C2.64278 13.4822 2.5325 12.9921 2.7087 12.5669C2.8849 12.1418 3.3095 11.8734 3.76914 11.8967L4.54747 11.9358C4.85511 11.9518 5.1551 11.8366 5.37292 11.6188C5.59074 11.401 5.70597 11.101 5.68997 10.7933L5.65081 10.015C5.62754 9.55537 5.89591 9.13077 6.32108 8.95457C6.74624 8.77837 7.23629 8.88865 7.54497 9.23001L8.06747 9.81335Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.87497 16.6883C9.73792 16.6883 10.4375 15.9888 10.4375 15.1258C10.4375 14.2629 9.73792 13.5633 8.87497 13.5633C8.01203 13.5633 7.31247 14.2629 7.31247 15.1258C7.31247 15.9888 8.01203 16.6883 8.87497 16.6883Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5316 6.16668C17.3591 6.16668 17.2191 6.30659 17.2191 6.47918C17.2191 6.65177 17.3591 6.79168 17.5316 6.79168C17.7042 6.79168 17.8441 6.65177 17.8441 6.47918C17.8441 6.30659 17.7042 6.16668 17.5316 6.16668Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.6616 3.54001C19.8927 3.45007 20.155 3.50518 20.3303 3.68049C20.5056 3.8558 20.5608 4.11815 20.4708 4.34918L20.0541 5.42085C19.9552 5.67479 20.0325 5.96356 20.245 6.13418L21.1408 6.85418C21.334 7.00929 21.4173 7.26385 21.3532 7.50315C21.2892 7.74246 21.0898 7.92133 20.845 7.95918L19.7091 8.13501C19.4398 8.1762 19.2283 8.38738 19.1866 8.65668L19.0108 9.79335C18.973 10.0382 18.7941 10.2375 18.5548 10.3016C18.3155 10.3657 18.0609 10.2823 17.9058 10.0892L17.1858 9.19335C17.0151 8.98099 16.7266 8.90348 16.4725 9.00168L15.4008 9.41835C15.1698 9.50829 14.9074 9.45318 14.7321 9.27787C14.5568 9.10256 14.5017 8.84021 14.5916 8.60918L15.0083 7.53751C15.1073 7.28357 15.03 6.99479 14.8175 6.82418L13.9216 6.10335C13.7288 5.94837 13.6458 5.69415 13.7098 5.45523C13.7739 5.2163 13.973 5.03775 14.2175 5.00001L15.3533 4.82418C15.6227 4.78239 15.834 4.57105 15.8758 4.30168L16.0516 3.16668C16.0891 2.9218 16.2678 2.72224 16.5071 2.65813C16.7464 2.59402 17.0009 2.67749 17.1558 2.87085L17.8766 3.76668C18.0474 3.97897 18.336 4.05618 18.59 3.95751L19.6616 3.54001Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPatGenerators);
export { ForwardRef as ReactComponent };
